'use strict';
import {module} from '../app';

module.service('SurveyService', [
    '$http', '$q', 'authService', 'magViewApi', function ($http, $q, authService, magViewApi) {
      return {
        getAllSurveys: function (patient) {
          return $http.get(authService.currentMagViewUrl() + '/api/v2/survey/allSurveys');
        },
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/domains/survey.js